import { render, staticRenderFns } from "./MyRegistration.vue?vue&type=template&id=f2e325ac&scoped=true&"
import script from "./MyRegistration.vue?vue&type=script&lang=js&"
export * from "./MyRegistration.vue?vue&type=script&lang=js&"
import style0 from "./MyRegistration.vue?vue&type=style&index=0&id=f2e325ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e325ac",
  null
  
)

export default component.exports